import { Navigation } from 'swiper';
import { SwiperProps } from 'swiper/react';

export const swiperMain: SwiperProps = {
  slidesPerView: 1,
  speed: 800,
  modules: [Navigation],
  allowTouchMove: true,
  navigation: {
    prevEl: '.team__nav-btn_prev',
    nextEl: '.team__nav-btn_next',
  },
  breakpoints: {
    991: {
      allowTouchMove: false,
    },
  },
};

export const swiperChild: SwiperProps = {};

export const swiperMobile: SwiperProps = {
  slidesPerView: 1,
  breakpoints: {
    465: {
      slidesPerView: 2,
    },
    650: {
      slidesPerView: 3,
    },
  },
};

export function getBreakpoints(countItems: number) {
  return {
    768: {
      slidesPerView: Math.min(countItems, 3),
    },
    865: {
      slidesPerView: Math.min(countItems, 4),
    },
    991: {
      slidesPerView: Math.min(countItems, 5),
    },
  };
}
